/**
 * Tab ID Utility
 * Generates and manages unique tab identifiers for chat isolation
 */

/**
 * Generate a unique tab ID
 */
const generateTabId = (): string => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substr(2, 9);
  return `tab_${timestamp}_${random}`;
};

/**
 * Get or create tab ID for current tab
 * Stored in sessionStorage (unique per tab)
 */
export const getTabId = (): string => {
  const STORAGE_KEY = 'bluepill_tab_id';

  // Check if tab ID already exists in sessionStorage
  let tabId = sessionStorage.getItem(STORAGE_KEY);

  if (!tabId) {
    // Generate new tab ID if not exists
    tabId = generateTabId();
    sessionStorage.setItem(STORAGE_KEY, tabId);
    console.log(`🔖 Generated new tab ID: ${tabId}`);
  }

  return tabId;
};

/**
 * Clear tab ID (useful for testing or reset)
 */
export const clearTabId = (): void => {
  const STORAGE_KEY = 'bluepill_tab_id';
  sessionStorage.removeItem(STORAGE_KEY);
  console.log('🔖 Tab ID cleared');
};

export default getTabId;
